import React from 'react'
import Box from '@mui/material/Box'
import { AudioDetails, MediaType, Resolutions, SubtitleType, VideoDetails } from '../../lib/types'
import { VideoJsPlayerOptions } from 'video.js'
import { BookmarkAudioJsWrapper, BookmarkVideoJsWrapper } from './BookmarkVideoJs'

interface iVideoPlayer {
  media?: VideoDetails | AudioDetails
  cover?: string
  defaultRes?: Resolutions
  type?: MediaType
  subtitles?: SubtitleType[]
  autoplay?: boolean
  handleEnd?: () => void
  maxHeight?: string
  mobileMaxHeight?: string
  onPlay?: (time: number) => void
  playlist?: any
  onLoadedMetaData?: (item: any) => void
  onPause?: () => void
  onPressPlay?: () => void
  borderRadius?: string
  playsInline?: boolean
  chapters?: { kind: string; src: string }
}

const BookmarkPlayer: React.FC<iVideoPlayer> = ({
  autoplay,
  handleEnd,
  subtitles,
  media,
  type,
  cover,
  onPlay,
  playlist,
  onLoadedMetaData,
  onPause,
  onPressPlay,
  borderRadius = '0px',
  playsInline = false,
  chapters
}) => {
  const options: VideoJsPlayerOptions = {
    poster: cover,
    responsive: true,
    preload: 'auto',
    controls: true,
    fill: true,
    muted: false,
    autoplay: autoplay,
    notSupportedMessage:
      'Your recording is still processing. Please wait a few moments, then refresh the page and try again.'
  }

  if (type === 'VIDEO') {
    const { id, gifUrl, url } = media as VideoDetails

    options.sources = [
      {
        src: url as string,
        type: 'video/mp4'
      }
    ]
    return (
      <BookmarkVideoJsWrapper
        subtitles={subtitles}
        key={id}
        mediaId={id}
        handleEnd={handleEnd}
        preview={gifUrl}
        options={options}
        onPlay={onPlay}
        playlist={playlist}
        onLoadedMetaData={onLoadedMetaData}
        onPause={onPause}
        onPressPlay={onPressPlay}
        borderRadius={borderRadius}
        playsInline={playsInline}
        chapters={chapters}
      />
    )
  }

  if (type === 'AUDIO') {
    const { id, url } = media as AudioDetails
    options.sources = [
      {
        src: url!,
        type: 'audio/mp3'
      }
    ]
    return (
      <Box sx={{ maxHeight: { xs: '100vh' }, height: { xs: '100vh' } }}>
        <BookmarkAudioJsWrapper
          subtitles={subtitles}
          key={id}
          handleEnd={handleEnd}
          id={media?.id || ''}
          options={options}
          onPlay={onPlay}
          playlist={playlist}
          onLoadedMetaData={onLoadedMetaData}
          onPause={onPause}
          onPressPlay={onPressPlay}
          borderRadius={borderRadius}
        />
      </Box>
    )
  }

  return null
}

export default BookmarkPlayer
